// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/inactive_upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/active_upload.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-modal-text .modal-container {
	padding: 0;
	display: flex;
	direction: legacy;
	align-content: stretch;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.upload-modal-text .upload-area {
	padding: 0px;
	border: none !important;
}

.upload-modal-text .application-selector {
	display: flex;
	align-items: center;
	font-size: 14px;
	width: 100%;
	box-sizing: border-box;
	flex-wrap: wrap;
	align-content: space-around;
	justify-content: center;
	margin-bottom: 15px;
}

.upload-text-p {
	color: var(--black, #000);
	text-align: center;
	font-family: 'SegoeUI-SemiBold';
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}

.upload-text-p a {
	content: #5f09e0;
	margin-left: 7px;
}

.application-selector-provider {
	padding-top: 20px;
}

.upload-modal-text .application-selector span {
	margin-right: 8px;
}

.application-selector-text {
	color: #696969;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-weight: 400;
}

.application-selector-name {
	color: var(--Black-60, #000);
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.upload-modal-text .upload-area-container {
	border-radius: 8px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	cursor: pointer;
	width: 744px;
	height: 280px;
	white-space: nowrap;
}

.upload-modal-text .upload-area-container:hover {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.upload-modal-text .ant-upload,
.upload-modal-text .ant-upload-select {
	border: none;
}

.upload-modal-text .ant-upload,
.upload-modal-text .ant-upload-select {
	display: inline-block !important;
	width: auto !important;
}

.upload-modal-text .upload-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.upload-modal-text .upload-icon {
	width: 52px;
	height: 72px;
	margin-bottom: 12px;
	margin-top: 48px;
}

.upload-modal-text .upload-text {
	color: #333;
	font-size: 15px;
	margin-bottom: 6px;
	white-space: nowrap;
	text-align: center;
}

.ant-select-outlined.ant-select-status-error:not(.ant-select-customize-input) .ant-select-selector {
	border: 1px solid #cc3939 !important;
}

.ant-select-outlined.ant-select-status-error:not(.ant-select-customize-input) .ant-select-selector:focus {
	border: 1px solid #cc3939 !important;
}

.upload-modal-text .select-file-link {
	color: #5f09e0;
	text-decoration: underline;
	font-weight: 500;
}

.upload-modal-text .support-text {
	color: var(--Gry_707070, #707070);
	text-align: center;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.upload-modal-text .support-text.unsupported-text {
	color: #ff4d4f;
}

.upload-modal-text .error-text {
	color: #cc3939;
	font-family: Segoe UI;
	font-weight: 400;
	font-style: Regular;
	font-size: 14px;
	leading-trim: NONE;
	letter-spacing: 0px;
	text-align: center;
	vertical-align: middle;
}

.upload-modal-text .progress-container {
	width: 90%;
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.upload-modal-text .progress-text {
	text-align: center;
	margin-top: 8px;
	font-size: 14px;
	color: #333;
	width: 100%;
}

.upload-modal-text .ant-progress {
	width: 100%;
}

.uploading-progress {
	width: 85%;
}

.upload-modal-text .ant-progress-bar {
	background-color: #e5e5e5;
	height: 10px;
	border-radius: 5px;
}

.upload-modal-text .ant-progress.ant-progress-status-success .ant-progress-bg {
	background-color: #2ecc71 !important;
}

.upload-modal-text .ant-progress-bar-fill {
	background-color: #2ecc71 !important;
	height: 100%;
	border-radius: 5px;
	transition: width 0.3s ease;
}

.upload-modal-text .ant-progress-status-success .ant-progress-bar-fill {
	background-color: #2ecc71 !important;
}

.upload-modal-text .ant-progress-status-success .ant-progress-bg {
	background-color: #e5e5e5;
}

.upload-modal-text .progress-bar-fill {
	height: 100%;
	background-color: #2ecc71;
	border-radius: 3px;
	transition: width 0.3s;
}

.upload-modal-text .modal-footer-knowledge {
	display: flex;
	justify-content: center;
	margin-top: 24px;
	gap: 16px;
}

.upload-modal-text .cancel-btn {
	background-color: #fff;
	color: #333;
	border: 1px solid #d9d9d9;
	border-radius: 16px;
	margin-right: 24px;
}

.upload-modal-text .add-btn {
	color: white;
	border-radius: 16px;
	margin-left: 24px;
	background: var(--DX-Purple, #5f09e0) !important;
}

.modal-footer-text {
	display: flex;
	justify-content: center;
	margin: 30px 0px;
}

.upload-modal-text .upload-area-container .uploading-progress span {
	text-align: right;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #22a35f;
}

.success-text {
	font-family: Segoe UI;
	font-weight: 400;
	font-style: Regular;
	font-size: 14px;
	line-height: 100%;
	letter-spacing: 0px;
	text-align: center;
	vertical-align: middle;
	color: #22a35f;
	text-align: center;
	margin-top: 30px;
}

.success-text img {
	width: 24px;
	height: 24px;
	margin-bottom: -5px;
}

.upload-modal-text
	.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(
		.ant-pagination-size-changer
	):hover
	.ant-select-selector {
	border-color: #cc3939 !important;
	box-shadow: none !important;
}

.add-btn-disable.ant-btn-color-purple.ant-btn-variant-solid {
	background-color: #efe6fc !important;
	color: #fff8f8 !important;
	border-color: #fff;
}

.add-btn-disable {
	background: #efe6fc !important;
	background-color: #efe6fc !important;
	color: #fff8f8 !important;
	text-align: center;
	font-family: SegoeUI-SemiBold;
	font-size: 14px;
	font-style: normal;
	line-height: normal;
	border-radius: 16px;
	margin-left: 24px;
}

.download-template-link {
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: underline;
	padding-top: 8px;
}

.download-template-link .template-icon {
	width: 19px;
	height: 19px;
	margin-right: 8px;
}

.modelTable table > thead > tr:first-child > *:last-child {
	text-align: start !important;
}

.modelTable {
	padding-top: 40px;
}

.modelTable .ant-table-thead > tr > th {
	background-color: #f4f4f4 !important;
	height: 40px !important;
	line-height: 40px;
	padding: 0 12px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/resource/text-base/components/upload-modal.css"],"names":[],"mappings":"AAAA;CACC,UAAU;CACV,aAAa;CACb,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,2BAA2B;CAC3B,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,+BAA+B;CAC/B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yDAA+D;CAC/D,4BAA4B;CAC5B,2BAA2B;CAC3B,wBAAwB;CACxB,eAAe;CACf,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,yDAA6D;AAC9D;;AAEA;;CAEC,YAAY;AACb;;AAEA;;CAEC,gCAAgC;CAChC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;CACpC,YAAY;CACZ,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,gDAAgD;AACjD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;;AAEA;;;;;CAKC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC,yBAAyB;CACzB,kBAAkB;CAClB,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;CACvB,iBAAiB;CACjB,0BAA0B;AAC3B","sourcesContent":[".upload-modal-text .modal-container {\n\tpadding: 0;\n\tdisplay: flex;\n\tdirection: legacy;\n\talign-content: stretch;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.upload-modal-text .upload-area {\n\tpadding: 0px;\n\tborder: none !important;\n}\n\n.upload-modal-text .application-selector {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 14px;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tflex-wrap: wrap;\n\talign-content: space-around;\n\tjustify-content: center;\n\tmargin-bottom: 15px;\n}\n\n.upload-text-p {\n\tcolor: var(--black, #000);\n\ttext-align: center;\n\tfont-family: 'SegoeUI-SemiBold';\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n}\n\n.upload-text-p a {\n\tcontent: #5f09e0;\n\tmargin-left: 7px;\n}\n\n.application-selector-provider {\n\tpadding-top: 20px;\n}\n\n.upload-modal-text .application-selector span {\n\tmargin-right: 8px;\n}\n\n.application-selector-text {\n\tcolor: #696969;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.application-selector-name {\n\tcolor: var(--Black-60, #000);\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.upload-modal-text .upload-area-container {\n\tborder-radius: 8px;\n\tbackground-image: url('/src/assets/images/inactive_upload.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tcursor: pointer;\n\twidth: 744px;\n\theight: 280px;\n\twhite-space: nowrap;\n}\n\n.upload-modal-text .upload-area-container:hover {\n\tbackground-image: url('/src/assets/images/active_upload.svg');\n}\n\n.upload-modal-text .ant-upload,\n.upload-modal-text .ant-upload-select {\n\tborder: none;\n}\n\n.upload-modal-text .ant-upload,\n.upload-modal-text .ant-upload-select {\n\tdisplay: inline-block !important;\n\twidth: auto !important;\n}\n\n.upload-modal-text .upload-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\theight: 100%;\n}\n\n.upload-modal-text .upload-icon {\n\twidth: 52px;\n\theight: 72px;\n\tmargin-bottom: 12px;\n\tmargin-top: 48px;\n}\n\n.upload-modal-text .upload-text {\n\tcolor: #333;\n\tfont-size: 15px;\n\tmargin-bottom: 6px;\n\twhite-space: nowrap;\n\ttext-align: center;\n}\n\n.ant-select-outlined.ant-select-status-error:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: 1px solid #cc3939 !important;\n}\n\n.ant-select-outlined.ant-select-status-error:not(.ant-select-customize-input) .ant-select-selector:focus {\n\tborder: 1px solid #cc3939 !important;\n}\n\n.upload-modal-text .select-file-link {\n\tcolor: #5f09e0;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n}\n\n.upload-modal-text .support-text {\n\tcolor: var(--Gry_707070, #707070);\n\ttext-align: center;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.upload-modal-text .support-text.unsupported-text {\n\tcolor: #ff4d4f;\n}\n\n.upload-modal-text .error-text {\n\tcolor: #cc3939;\n\tfont-family: Segoe UI;\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tfont-size: 14px;\n\tleading-trim: NONE;\n\tletter-spacing: 0px;\n\ttext-align: center;\n\tvertical-align: middle;\n}\n\n.upload-modal-text .progress-container {\n\twidth: 90%;\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.upload-modal-text .progress-text {\n\ttext-align: center;\n\tmargin-top: 8px;\n\tfont-size: 14px;\n\tcolor: #333;\n\twidth: 100%;\n}\n\n.upload-modal-text .ant-progress {\n\twidth: 100%;\n}\n\n.uploading-progress {\n\twidth: 85%;\n}\n\n.upload-modal-text .ant-progress-bar {\n\tbackground-color: #e5e5e5;\n\theight: 10px;\n\tborder-radius: 5px;\n}\n\n.upload-modal-text .ant-progress.ant-progress-status-success .ant-progress-bg {\n\tbackground-color: #2ecc71 !important;\n}\n\n.upload-modal-text .ant-progress-bar-fill {\n\tbackground-color: #2ecc71 !important;\n\theight: 100%;\n\tborder-radius: 5px;\n\ttransition: width 0.3s ease;\n}\n\n.upload-modal-text .ant-progress-status-success .ant-progress-bar-fill {\n\tbackground-color: #2ecc71 !important;\n}\n\n.upload-modal-text .ant-progress-status-success .ant-progress-bg {\n\tbackground-color: #e5e5e5;\n}\n\n.upload-modal-text .progress-bar-fill {\n\theight: 100%;\n\tbackground-color: #2ecc71;\n\tborder-radius: 3px;\n\ttransition: width 0.3s;\n}\n\n.upload-modal-text .modal-footer-knowledge {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 24px;\n\tgap: 16px;\n}\n\n.upload-modal-text .cancel-btn {\n\tbackground-color: #fff;\n\tcolor: #333;\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 16px;\n\tmargin-right: 24px;\n}\n\n.upload-modal-text .add-btn {\n\tcolor: white;\n\tborder-radius: 16px;\n\tmargin-left: 24px;\n\tbackground: var(--DX-Purple, #5f09e0) !important;\n}\n\n.modal-footer-text {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin: 30px 0px;\n}\n\n.upload-modal-text .upload-area-container .uploading-progress span {\n\ttext-align: right;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\tcolor: #22a35f;\n}\n\n.success-text {\n\tfont-family: Segoe UI;\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tfont-size: 14px;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcolor: #22a35f;\n\ttext-align: center;\n\tmargin-top: 30px;\n}\n\n.success-text img {\n\twidth: 24px;\n\theight: 24px;\n\tmargin-bottom: -5px;\n}\n\n.upload-modal-text\n\t.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(\n\t\t.ant-pagination-size-changer\n\t):hover\n\t.ant-select-selector {\n\tborder-color: #cc3939 !important;\n\tbox-shadow: none !important;\n}\n\n.add-btn-disable.ant-btn-color-purple.ant-btn-variant-solid {\n\tbackground-color: #efe6fc !important;\n\tcolor: #fff8f8 !important;\n\tborder-color: #fff;\n}\n\n.add-btn-disable {\n\tbackground: #efe6fc !important;\n\tbackground-color: #efe6fc !important;\n\tcolor: #fff8f8 !important;\n\ttext-align: center;\n\tfont-family: SegoeUI-SemiBold;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tline-height: normal;\n\tborder-radius: 16px;\n\tmargin-left: 24px;\n}\n\n.download-template-link {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-decoration: underline;\n\tpadding-top: 8px;\n}\n\n.download-template-link .template-icon {\n\twidth: 19px;\n\theight: 19px;\n\tmargin-right: 8px;\n}\n\n.modelTable table > thead > tr:first-child > *:last-child {\n\ttext-align: start !important;\n}\n\n.modelTable {\n\tpadding-top: 40px;\n}\n\n.modelTable .ant-table-thead > tr > th {\n\tbackground-color: #f4f4f4 !important;\n\theight: 40px !important;\n\tline-height: 40px;\n\tpadding: 0 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
